import { Button, EmptyPage } from "web/components"

export default function NoData({ handleAddItem, listTypeFriendlyName }) {
  return (
    <div className="my-5 mr-3 md:mr-5">
      <EmptyPage
        message={`There is nothing to show. Your current filters may be hiding some items. Try changing your filters or adding a new ${listTypeFriendlyName.toLowerCase()} to get started.`}
      >
        {handleAddItem && (
          <div className="m-5">
            <Button
              onClick={handleAddItem}
            >{`Add ${listTypeFriendlyName}`}</Button>
          </div>
        )}
      </EmptyPage>
    </div>
  )
}
